require('../es');
require('../web');
var path = require('../internals/path');

module.exports = path;



//////////////////
// WEBPACK FOOTER
// c:/Users/Antanas/Dropbox/am/Projects/typescript/amcharts4dev/node_modules/core-js/stable/index.js
// module id = nj15
// module chunks = a74a